<template>
  <iframe ref="iframe" style="width:100%; border:none;"></iframe>
</template>

<script>
export default {
  props: [
    'userImie',
    'userNazwisko',
    'userEmail',
    'userPhone',
    'stanowisko_en',
    'stanowisko',
    'departament_name',
    'departament_name_en'
  ],

  mounted() {
    const doc = this.$refs.iframe.contentDocument;

    let phoneHtml = '';
    if (this.userPhone && this.userPhone.trim() !== '') {
      phoneHtml = `Mobile: ${this.userPhone}<br>`;
    }
    let signatureContent = '';

    if (this.stanowisko_en && this.stanowisko_en.trim() !== '') {
      signatureContent = `
        <span style="font-family: Arimo; color: black; font-size: 9pt; line-height:1">
          <br>Best Regards
        </span>

        <span style="font-family: Arimo; color: black; font-size: 8pt; line-height:0.5">
          <br><br>
        </span>

        <span style="font-family: Arimo; color: #FF8C00; font-size: 9pt; line-height:2">
          <b>${this.userImie} ${this.userNazwisko}</b><br>
        </span>

        <span style="font-family: Arimo; color: #FF8C00; font-size: 9pt; line-height:1">
          ${this.stanowisko_en}<br>
          ${this.departament_name_en}<br>
        </span><br>

        <span style="font-family: Arimo; color: black; font-size:8pt">
          ${phoneHtml}
          Tel.: +48 512 011 747<br>
          E-mail: ${this.userEmail}<br>
        </span><br>

        <br>
        <img
          src="https://www.askla.pl/templates/askla_template/images/logo_small.png"
          alt="ASKLA"
          border="0"
          style="display:block;"
        >
        <br><br>

        <span style="font-family: Arimo; color: black; font-size:8pt">
          ASKLA Automatyka Serwis<br>
          Józef Klabis<br>
          Lubliniecka 50<br>
          46-380 Dobrodzień<br>
          TIN: 5751069325<br>
          Business ID: 150217335<br><br>

          <b>PRODUCTION DEPARTMENT: </b><br>
          Nowy Dwór 12<br>
          42-793 Ciasna<br>
        </span>

        <span style="font-family: Arimo; color: black; font-size:7pt">
          <br><i>
            The above message and all its attachments are confidential and may be legally privileged.<br>
            If you are not the intended recipient, you must not disclose, copy, distribute, or otherwise use this message or any part of it.<br>
            If you have received this message in error, please notify the sender immediately and delete it.<br>
            Information regarding personal data protection is available on the company’s website: <a href="https://askla.pl/rodo/">https://askla.pl/rodo/</a>
          </i>
        </span>
      `;
    } else {
      signatureContent = `
        <span style="font-family: Arimo; color: black; font-size: 9pt; line-height:1">
          <br>Pozdrawiam / Mit freundlichen Grüßen / Best Regards
        </span>

        <span style="font-family: Arimo; color: black; font-size: 8pt; line-height:0.5">
          <br><br>
        </span>

        <span style="font-family: Arimo; color: #FF8C00; font-size: 9pt; line-height:2">
          <b>${this.userImie} ${this.userNazwisko}</b><br>
        </span>

        <span style="font-family: Arimo; color: #FF8C00; font-size: 9pt; line-height:1">
          ${this.stanowisko}<br>
          ${this.departament_name}<br>
        </span><br>

        <span style="font-family: Arimo; color: black; font-size:8pt">
          ${phoneHtml}
          Tel.: +48 512 011 747<br>
          E-mail: ${this.userEmail}<br>
        </span><br>

        <br>
        <img
          src="https://www.askla.pl/templates/askla_template/images/logo_small.png"
          alt="ASKLA"
          border="0"
          style="display:block;"
        >
        <br><br>

        <span style="font-family: Arimo; color: black; font-size:8pt">
          ASKLA Automatyka Serwis<br>
          Józef Klabis<br>
          ul. Lubliniecka 50<br>
          46-380 Dobrodzień<br>
          NIP: 5751069325<br>
          Regon: 150217335<br><br>

          <b>ODDZIAŁ PRODUKCYJNY: </b><br>
          ul. Nowy Dwór 12a<br>
          42-793 Ciasna<br>
        </span>

        <span style="font-family: Arimo; color: black; font-size:7pt">
          <br><i>
            Powyższa wiadomość oraz wszystkie jej załączniki są poufne i mogą podlegać ochronie prawnej.<br>
            Jeżeli nie jest Pan/Pani jej zamierzonym adresatem, nie może jej Pan/Pani ujawniać,<br>
            kopiować ani też w żaden inny sposób udostępniać lub wykorzystywać.<br>
            O błędnym zaadresowaniu wiadomości prosimy niezwłocznie poinformować nadawcę i usunąć wiadomość.<br>
            Informacje dotyczące ochrony danych osobowych zamieszczone są na stronie internetowej firmy:
            <a href="https://askla.pl/rodo/">https://askla.pl/rodo/</a>
          </i>
        </span>
      `;
    }

    doc.open();

    doc.write(`
      <table cellpadding="0" cellspacing="0" border="0" style="font-family: Arimo; font-size:5pt; color:black;">
        <tr>
          <td>
            ${signatureContent}
          </td>
        </tr>
      </table>
    `);

    doc.close();

    // dopasowanie wysokości iframe
    this.$refs.iframe.onload = () => {
      this.$refs.iframe.style.height =
        this.$refs.iframe.contentDocument.body.scrollHeight + 'px';
    };
  }
}
</script>

<style>
</style>